import {get, post, postWithConfig} from '@/utils/request'
import {getCookie} from '@/utils/cookie'
// import { GATEWAY_HOST } from '@/constants/host'
const baseURL = ''//'https://capi.staff.xdf.cn/mock/925';
// const staffId = sessionStorage.getItem('currentStaffId') || ''
console.log('common')


export const  getStaffInfoList = (params = {}) => {
    return  get(baseURL + "/api/staff/info/query",{...params})
};
export const  refreshStaffInfoList = (params = {}) => {
    return  get(baseURL + "/api/staff/info/refresh",{...params})
};




/**
 * 分组列表
 * @param {
 * * classCode 班级ID
 * * groupClassNo 分组班号
 * * schoolId 学校Id
 * 
 * * email 员工邮箱
 * } params 
 * @returns 
 */
export const getGroupListByClass = (params = {})=>{
    return get(baseURL + '/api/group/listByClass',{...params})
}

/**
 * 学习机大组 分组列表
 * learnMachineGroupCode
 *  schoolId 学校Id
 */
export const getLearnMachineGroupList = (params={})=>{
    return get (baseURL + '/api/group/listByGroup',{...params});
}

/**
 * 学习机小组 分组列表
 * learnMachineGroupCode
 *  schoolId 学校Id
 */
export const getLearnMachineSmallGroupList = (params={})=>{
    return get (baseURL + '/api/group/listBySubGroup',{...params});
}


/**
 * 班级学员列表
 * @param {
 * * classCode 班级编码
 * * groupClassNo 分组号
 * * schoolId 学校ID
 * 
 * * email 员工邮箱
 * * staffId 员工staffId
 * } params 
 * @returns 
 */
export const getStudentListByClass = (params={})=>{
    if(!params.schoolId)return Promise.resolve([])
    return get(baseURL + '/api/class/student/list',{...params,staffId: sessionStorage.getItem('currentStaffId')})
}

/**
 * 学习机大组学生列表
 * learnMachineGroupCode
 * groupId
 * schoolId
 * staffId
 */
export const getLearnMachineStudentList = (params={})=>{
    if(!params.schoolId)return Promise.resolve([])
    return get(baseURL + '/api/learn/machine/student/list',{...params,staffId: sessionStorage.getItem('currentStaffId')})
}

/**
 * 学习机小组学生列表
 * learnMachineGroupCode
 * groupId
 * schoolId
 * staffId
 */
export const getLearnMachineSmallStudentList = (params={})=>{
    if(!params.schoolId)return Promise.resolve([])
    return get(baseURL + '/api/learn/machine/sub/student/list',{...params,staffId: sessionStorage.getItem('currentStaffId')})
}


/**
 * 教师一对一学员列表
 * staffId
 * classStatus  学员状态，1-在读，2-结课，3-未开课
 * @param {*} params 
 */
export const getOne2OneStudentList = (params = {})=>{
    return get(baseURL + '/api/teachers/student/list',{...params,staffId: sessionStorage.getItem('currentStaffId')})
}


/**
 * 查询好友列表
 * @param {
 * * keyword: 关键词
 * * staffId 员工staffId
 * } params 
 * @returns 
 */
export const getWxListByName = (params={}) =>{
    console.log('getWxListByName',params.keyword) ;
    return postWithConfig(baseURL + '/api/friend/list',{...params,keyword:(params.keyword) || '',staffId: sessionStorage.getItem('currentStaffId')},{
        headers:{"content-type": "application/x-www-form-urlencoded"},
        timeout: 5000
    })
}

/**
 * 查询群列表
 * @param {
 * * keyword 关键词
 * * staffId 员工staffId
 * } params 
 * 
 */
export const getWxGroupListByName = (params={}) =>{
    // console.log('getWxGroupListByName',encodeURIComponent(params.keyword))
    return postWithConfig(baseURL + '/api/group/list',{...params,keyword:(params.keyword) || '',staffId: sessionStorage.getItem('currentStaffId')},{
        headers:{"content-type": "application/x-www-form-urlencoded"},
        timeout: 5000
    })
}

/**
 * 编辑学员接收消息的微信名和微信群
 * @param {
 * * nickName 昵称
 * * receiveWeChatGroupName 微信群
 * * receiveWeChatName 微信名
 * * studentCode 学员编码
 * * staffId 员工staffId
 * } params 
 * @returns 
 */
export const editStudentReceiveWeChatInfo = (params={})=>{
    return post(baseURL + '/api/student/editStudentReceiveWeChatInfo',{...params,staffId: sessionStorage.getItem('currentStaffId') })
}

/**
 * 批量编辑学员接收消息的微信名和微信群
 * @param {
 * * staffId 员工staffId
 * * list <{studentCode,nickName,receiveWeChatName,receiveWeChatRemark,receiveWeChatGroupName,chatId,unionId}>[]
 * } params 
 * @returns 
 */
export const batchEditStudentReceiveWeChatInfo = (params={})=>{
    return post(baseURL + '/api/student/batchEditStudentReceiveWeChatInfo',{...params,staffId: sessionStorage.getItem('currentStaffId') })
}


/**
 * 根据学员的student Code获取最新的学员对应微信和微信群名
 * studentCodes:[]
 * @param {*} params 
 * @returns 
 */
export const getLatestStudentQwInfo = (params={}) => {
    return post(baseURL + '/api/student/batchGetStudentReceiveWeChatInfo',{...params,staffId: sessionStorage.getItem('currentStaffId') })
}

/**
 * 获取学校二维码信息
 * staffId
 * classStatus  学员状态，1-在读，2-结课，3-未开课
 * @param {*} params 
 */
export const supportGroupList = (params = {})=>{
    return get(baseURL + '/api/supportGroup/list',{...params})
}

/**
 * 获取版本列表
 */
export const getLatestVersionInfo = (params = {})=>{
    return get(baseURL + '/magic/app/version/list',{...params})
}